import React, { useEffect, useState } from 'react';
import AxiosClient from '../../assets/AxiosClient';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useStateContext } from '../../Contexts/ContextProvider.jsx';
import Countries from "../../Forms/Data/Countries.js";
import Positions from "../../Forms/Data/Positions.js" 
import nationalities from "../../Forms/Data/nationalities.js" 

import InputSelect from '../../Forms/InputSelect.jsx';
import Loader from '../../assets/tools/Loder/loader';

const EditAttendant = () => {
  const { SetNotification, API } = useStateContext();
  const [user, setUser] = useState(null);
  const [loading, setIsLoading] = useState(true);
  const { id } = useParams();
  const [att_id, setAtt_id] = useState(0);
  const [first_name, setFirstName] = useState('');
  const [middle_name, setMiddleName] = useState('');
  const [last_name, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [position, setPosition] = useState('');
  const [gender, setGender] = useState('');
  const [country, setCountry] = useState('');
  const [organization, setOrganization] = useState('');
  const [nationality, setNationality] = useState('');
  const [phone, setPhone] = useState('');
  const [role, setRole] = useState('');
  const [present, setPresent] = useState('');

  const navigate = useNavigate();
  const country_names = Countries.map (country=> country.name); 

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await AxiosClient.get(`/Registeration/show/${id}`);
        if (response.status === 200) {
          console.log(response);
          const { user, lastAttend } = response.data;
          setUser(user);
          setAtt_id(lastAttend);
          setFirstName(user.first_name);
          setMiddleName(user.middle_name);
          setLastName(user.last_name);
          setEmail(user.email);
          setPosition(user.position);
          setGender(user.gender);
          setCountry(user.country);
          setOrganization(user.organization);
          setNationality(user.nationality);
          setPhone(user.phone);
          setRole(user.role);
          setIsLoading(false);
          setPresent(user.present)
        }
      } catch (error) {
        console.log('Error fetching data:', error);
        setIsLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const handleCancel = async () => {
    navigate(-1);
  };

  const handleSave = async () => {
    try {
      const response = await AxiosClient.put(`/Users/${id}`, {
        first_name,
        middle_name,
        last_name,
        email,
        position,
        gender,
        country,
        organization,
        nationality,
        phone,
        role,
      });
      if (response.status === 200) {
        SetNotification( 'Attendant updated successfully.' ,'success');

        navigate(-1);
      }
    } catch (error) {
      console.log('Error updating attendant:', error);
      SetNotification( 'Failed to update attendant.' , 'danger');
    }
  };
  const handelDelete = async()=>{
    const confirmed = window.confirm('Are you sure you want to delete this user ?');
    if (confirmed) {
      await AxiosClient.delete("Users/" + id ).then(()=>{
        SetNotification( 'User has been Deleted successfully.' ,'success');
        navigate("/Attendants");

      }).catch(({response})=> SetNotification( response.data.message ,'danger')); 

    }
  
}

  return (
    <>
      <div className="card">
        <div className="card-header">
          <h4 className="card-title">Edit Attendant</h4>
        </div>
        {loading ? (
          <Loader label="Loading attendant details..." />
        ) : (
          <div className="card-body">
            <div className="card-content text-dark">
              <div className="row">
                <div className="col-6">
                  <h5>First Name</h5>
                  <div className="input-group input-group-outline mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter First Name"
                      value={first_name}
                      onChange={(e) => setFirstName(e.target.value)}
                      required
                    />
                  </div>
  
                  <h5>Middle Name</h5>
                  <div className="input-group input-group-outline mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Middle Name"
                      value={middle_name}
                      onChange={(e) => setMiddleName(e.target.value)}
                      required
                    />
                  </div>
  
                  <h5>Last Name</h5>
                  <div className="input-group input-group-outline mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Last Name"
                      value={last_name}
                      onChange={(e) => setLastName(e.target.value)}
                      required
                    />
                  </div>
  
                  <h5>Email</h5>
                  <div className="input-group input-group-outline mb-3">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Enter Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
  
                  <h5>Position</h5>
                  <div className="input-group input-group-outline mb-3">
                  <InputSelect title={" update Position"}  val={position} setval={setPosition} array={Positions}/> 
                </div>
               
                  <h5>Gender</h5>
                  <div className="input-group input-group-outline mb-3">
                  <InputSelect title={" update gender"}  val={gender} setval={setGender} array={["Male" , "Female"]}/> 

                    
                  </div>
  
                  <h5>Country</h5>
                  <div className="input-group input-group-outline mb-3">
                  <InputSelect title={" update Country  "}  val={country} setval={setCountry} array={country_names}/> 
                   
                  </div>
                </div>
  
                <div className="col-6">
                  <h5>Organization</h5>
                  <div className="input-group input-group-outline mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Organization"
                      value={organization}
                      onChange={(e) => setOrganization(e.target.value)}
                      required
                    />
                  </div>
  
                  <h5>Nationality</h5>
                  <div className="input-group input-group-outline mb-3">
                  <InputSelect title={" update Nationalty  "}  val={nationality} setval={setNationality} array={nationalities}/> 

                  </div>
  
                  <h5>Phone</h5>
                  <div className="input-group input-group-outline mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Phone"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      required
                    />
                  </div>
  
                  <h5>Role</h5>
                  <div className="input-group input-group-outline mb-3">
                  <InputSelect title={" update role"}  val={role} setval={setRole} array={["Guest" , "Researcher"]}/> 

                  
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="card-footer">
          <button className="btn btn-warning m-2 " onClick={handleCancel}>
            Cancel
          </button>
          <button className="btn btn-info m-2" onClick={handleSave}>
            Save
          </button>
          <div dir="rtl">
        <button className="btn btn-danger m-2" onClick={handelDelete}>
            Primary Delete this user
          </button>
          </div>
        </div>
       
      </div>
    
    </>
  );
        }
        export default EditAttendant;

